module.exports = __webpack_public_path__ + "media/images/official/plan_ticket_icon1-d78ecba905b20669046a6048b1fd0efe.svg";